module.exports = __webpack_public_path__ + "static/media/PushtimargImage4.83a0dd56.jpg";